export type ApprovalDecisionIntent = "approved" | "denied";
export type ApprovalDecisionSearch = { decision?: ApprovalDecisionIntent };

export const approvalDecisionIntent = (value: unknown): ApprovalDecisionIntent | undefined => (value === "approved" || value === "denied" ? value : undefined);

export const approvalDecisionSearch = (search: Record<string, unknown>): ApprovalDecisionSearch => {
  const decision = approvalDecisionIntent(search.decision);
  return decision ? { decision } : {};
};
